<!--
 * @Author: zs
 * @Date: 2022-04-21 10:54:15
 * @LastEditTime: 2022-04-22 17:26:43
 * @Description:
 * @FilePath: \smart-community\src\layout\module\menu\component\floatDialog.vue
-->
<!--floatDialog-->
<template>
  <div
    id="floatDialog"
    :style="{ width: wd, left: leftValue }"
    v-if="showFloatDialog"
  >
    {{ leftValue }}555
    <!-- <div class="float_box"></div> -->
    <slot></slot>
  </div>
</template>

<script>
import { defineComponent, onMounted } from "vue";
export default defineComponent({
  name: "floatDialog",
  components: {},
  props: {
    showFloatDialog: {
      type: Boolean,
      default: false,
    },
    wd: {
      type: String,
      default: "11vw",
    },
    leftValue: {
      type: String,
      default: "",
    },
  },
  setup(props, context) {
    onMounted(() => {});
  },
});
</script>
<style lang='scss' scoped>
@import "~@/assets/style/utils";
#floatDialog {
  height: auto;
  position: absolute;
  z-index: 1000;
  top: 10vh;
  background: #fff;
  // z-index: 2;
  font-size: 0.14rem;
  color: var(--info);
  border-radius: 15px;
  // border: 1px solid #f5f5f5;
  // box-shadow: 0 0 0.2rem rgab(0, 0, 0, 0.1);
  -moz-box-shadow: 0 0 10px rgba(0, 0, 0, 0.1); /* 老的 Firefox */
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}
@mixin bg($path) {
}
.simple {
  @include bg("simple");
}
</style>
